export const dashboardMetrics = [
    {key: 'visits', label: 'Visits'},
    {key: 'clicks', label: 'Clicks'},
    {key: 'conversionsAll', chartKey: 'conversions', label: 'Conversions'},
    {key: 'revenue', label: 'Revenue', currency: true},
    {key: 'cost', label: 'Cost', currency: true},
    {key: 'profit', label: 'Profit', currency: true}
];

export function formatMetric(value, metric, currencyCode = 'EUR', compact = false) {
    const number = Number(value);
    const options = metric.currency
        ? {style: 'currency', currency: currencyCode || 'EUR', maximumFractionDigits: 2}
        : {maximumFractionDigits: metric.key === 'roi' ? 2 : 0};
    if (compact) Object.assign(options, {notation: 'compact', maximumFractionDigits: 1});
    return new Intl.NumberFormat(undefined, options).format(Number.isFinite(number) ? number : 0)
        + (metric.key === 'roi' ? '%' : '');
}
